import { Form } from 'antd';
import { EMPLOYEE_FORM_GROUP_KEYS } from '@/shared/employee';
import { getFieldState } from '@/utils/formUtils';

/**
 * Keys and permission states of the company, status, personal, contact and bank fields.
 */
export default function useEmployeeGeneralFields({
  form,
  formFields,
  isEdited,
}) {
  const INPUT_KEYS = EMPLOYEE_FORM_GROUP_KEYS;

  // * Global form data
  const companyIdKeys = INPUT_KEYS.companyId;
  const companyIdState = getFieldState({
    formFields,
    formKeys: companyIdKeys[0].split('.'),
    isEdited,
  });

  const employeeSectorKeys = INPUT_KEYS.employeeSector;
  const employeeSectorState = getFieldState({
    formFields,
    formKeys: employeeSectorKeys[0].split('.'),
    isEdited,
  });

  const selectedCompany = Form.useWatch(companyIdKeys, form);

  const statusKeys = INPUT_KEYS.status;
  const statusState = getFieldState({
    formFields,
    formKeys: statusKeys.split('.'),
    isEdited,
  });

  const firstNameKeys = INPUT_KEYS.firstName;
  const firstNameState = getFieldState({
    formFields,
    formKeys: firstNameKeys.split('.'),
    isEdited,
  });

  const lastNameKeys = INPUT_KEYS.lastName;
  const lastNameState = getFieldState({
    formFields,
    formKeys: lastNameKeys.split('.'),
    isEdited,
  });

  // * General form data
  const emailKeys = INPUT_KEYS.generalData.email;
  const emailState = getFieldState({
    formFields,
    formKeys: emailKeys,
    isEdited,
  });

  const personalNumberKeys = INPUT_KEYS.generalData.personalNumber;
  const personalNumberState = getFieldState({
    formFields,
    formKeys: personalNumberKeys,
    isEdited,
  });

  const phoneKeys = INPUT_KEYS.generalData.phone;
  const phoneState = getFieldState({
    formFields,
    formKeys: phoneKeys,
    isEdited,
  });

  const countryKeys = INPUT_KEYS.generalData.country;
  const countryState = getFieldState({
    formFields,
    formKeys: countryKeys,
    isEdited,
  });

  const addressKeys = INPUT_KEYS.generalData.address;
  const addressState = getFieldState({
    formFields,
    formKeys: addressKeys,
    isEdited,
  });

  const cityKeys = INPUT_KEYS.generalData.city;
  const cityState = getFieldState({
    formFields,
    formKeys: cityKeys,
    isEdited,
  });

  const municipalityKeys = INPUT_KEYS.generalData.municipality;
  const municipalityState = getFieldState({
    formFields,
    formKeys: municipalityKeys,
    isEdited,
  });

  const positionKeys = INPUT_KEYS.generalData.position;
  const positionState = getFieldState({
    formFields,
    formKeys: positionKeys,
    isEdited,
  });

  const positionEngKeys = INPUT_KEYS.generalData.positionEng;
  const positionEngState = getFieldState({
    formFields,
    formKeys: positionEngKeys,
    isEdited,
  });

  const orgUnitKeys = INPUT_KEYS.generalData.orgUnit;
  const orgUnitState = getFieldState({
    formFields,
    formKeys: orgUnitKeys,
    isEdited,
  });

  const otherRemarksKeys = INPUT_KEYS.generalData.otherRemarks;
  const otherRemarksState = getFieldState({
    formFields,
    formKeys: otherRemarksKeys,
    isEdited,
  });

  const bankAccountsKeys = INPUT_KEYS.generalData.bankAccounts;
  const bankAccountsState = getFieldState({
    formFields,
    formKeys: bankAccountsKeys,
    isEdited,
  });

  const bankNameKeys = INPUT_KEYS.generalData.bankName;
  const bankNameState = getFieldState({
    formFields,
    formKeys: bankNameKeys,
    isEdited,
  });

  const isResidentKeys = INPUT_KEYS.generalData.isResident;
  const isResidentState = getFieldState({
    formFields,
    formKeys: isResidentKeys,
    isEdited,
  });

  return {
    INPUT_KEYS,
    addressKeys,
    addressState,
    bankAccountsKeys,
    bankAccountsState,
    bankNameKeys,
    bankNameState,
    cityKeys,
    cityState,
    companyIdKeys,
    companyIdState,
    countryKeys,
    countryState,
    emailKeys,
    emailState,
    employeeSectorKeys,
    employeeSectorState,
    firstNameKeys,
    firstNameState,
    isResidentKeys,
    isResidentState,
    lastNameKeys,
    lastNameState,
    municipalityKeys,
    municipalityState,
    orgUnitKeys,
    orgUnitState,
    otherRemarksKeys,
    otherRemarksState,
    personalNumberKeys,
    personalNumberState,
    phoneKeys,
    phoneState,
    positionEngKeys,
    positionEngState,
    positionKeys,
    positionState,
    selectedCompany,
    statusKeys,
    statusState,
  };
}
